import { Fade, Box, Typography, useMediaQuery } from "@mui/material";
import Lottie from "lottie-react";
import { FC, useEffect, useRef } from "react";
import sendAnimation from '../../../../../assets/animations/send.json'

interface ComplaintCompleteProps {
    activeStep: number;
}

const ComplaintComplete: FC<ComplaintCompleteProps> = ({
    activeStep,
}) => {
    const stepRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery("(max-width:550px)");

    useEffect(() => {
        if (activeStep === 5 && stepRef.current) {
            const top = stepRef.current.getBoundingClientRect().top + window.scrollY - (isMobile ? 80 : 1000);
            window.scrollTo({ top, behavior: "smooth" });
        }
    }, [activeStep, isMobile]);


    return (
        <Fade in>
            <Box sx={{ textAlign: "center", mt: 4 }}>
                <Typography
                    variant="h5"
                    color="#bfa14b"
                    fontWeight={700}
                    gutterBottom ref={stepRef}
                >
                    Dziękujemy za zgłoszenie!
                </Typography>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                    <Lottie
                        style={{
                            maxWidth: '250px',
                            maxHeight: '250px',
                        }}
                        animationData={sendAnimation}
                        loop={false}
                    />
                </Box>
                <Typography variant="body1" color="text.secondary">
                    Termin rozpatrzenia reklamacji wynosi 14 dni. O wyniku postępowania reklamacyjnego oraz zasadach dalszego postępowania z reklamowanym towarem poinformujemy Cię, wysyłając informację na adres e-mail podany w zgłoszeniu reklamacyjnym lub kontaktując się telefonicznie
                </Typography>
            </Box>
        </Fade>
    )
}

export default ComplaintComplete;